"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _IconPointerDownOutline = _interopRequireDefault(require("./IconPointerDownOutline"));
var IconPointerUpOutline = /*#__PURE__*/(0, _styledComponents.default)(_IconPointerDownOutline.default).withConfig({
  displayName: "IconPointerUpOutline",
  componentId: "c11n-8-107-0__sc-kkost4-0"
})(["transform:rotate(180deg);"]);
var _default = IconPointerUpOutline;
exports.default = _default;